import React, { useState } from 'react'

import { Table as AntTable, Button, Col, Row } from 'antd';
import Table, { ColumnsType } from 'antd/es/table';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Space, Switch } from 'antd';


import addicon from '../../assests/svg/add.svg'
import { Link, useNavigate } from 'react-router-dom';
import { components, getRowClassName } from '../../utils/utils';
import IMAGES from '../../const/Image';


const columns = [
    {
        title: 'S No.',
        dataIndex: 'sno',
        key: 'sno',
    },
    {
        title: 'Subscription Name',
        dataIndex: 'subscriptionName',
        key: 'subscriptionName',
    },
    {
        title: 'Subscription Tenure',
        dataIndex: 'subscriptionTenure',
        key: 'subscriptionTenure',
    },
    {
        title: 'Applicable All City',
        dataIndex: 'applicableAllCity',
        key: 'applicableAllCity',
    },
    {
        title: 'Applicable All Test',
        dataIndex: 'applicableAllTest',
        key: 'applicableAllTest',
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (status: boolean) => (
            <div>
                <Space direction="vertical">

                    <Switch checkedChildren="Active" unCheckedChildren="Inactive" />

                </Space>
            </div>
        )
    },
    {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',

    },
    // Add other columns as needed
];


const labList = [
    { id: 1, sno: 1, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 2, sno: 2, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 3, sno: 3, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 4, sno: 4, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 5, sno: 5, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 6, sno: 6, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 7, sno: 7, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 8, sno: 8, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 9, sno: 9, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 10, sno: 10, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 11, sno: 11, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 12, sno: 12, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 13, sno: 13, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
    { id: 14, sno: 14, subscriptionName: 'LPL Prime-Basic', subscriptionTenure: '3', applicableAllCity: 1, applicableAllTest: 1, status: 'active' },
];



const SubscriptionList = () => {

    const [loading, setloading] = useState(false)
    const navigate = useNavigate();
    return (
        <>
            <div className='subscription-hea' >
                <Row gutter={[8, 8]} justify="space-between" align="middle" >
                    <Col>
                        <h1 className="app-heading-med">Customers List</h1>
                    </Col>
                    <Col>
                        <Button
                            onClick={() => navigate("/subscription/add")}
                            type="primary"
                            htmlType="submit"
                            className="addcity-btn"
                        >
                            <img src={IMAGES.AddIconFilters} alt="" />
                        </Button>
                    </Col>
                </Row>


            </div>
            <div><Table size='middle' bordered rowClassName={getRowClassName}
                components={components} columns={columns} loading={loading} dataSource={labList} /></div>
        </>
    )
}

export default SubscriptionList
